function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import { apiRbacUserHasPermission } from "../services/apiRbacUserHasPermission";
import { APP_CODE } from "../const";
var rbacPermissionMap = new Map();
export var useRbacPermission = function useRbacPermission(rbac) {
  var _rbac$appCode = rbac.appCode,
    appCode = _rbac$appCode === void 0 ? APP_CODE : _rbac$appCode,
    showTypes = rbac.showTypes,
    uri = rbac.uri;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasPermission = _useState2[0],
    setHasPermission = _useState2[1];
  useEffect(function () {
    var refreshPermission = function refreshPermission() {
      if (appCode && uri) {
        if (rbacPermissionMap.has(uri)) {
          var _promise = rbacPermissionMap.get(uri);
          _promise === null || _promise === void 0 || _promise.then(function (result) {
            var timestamp = result.timestamp,
              hasPermission = result.hasPermission;
            // 有效缓存时间为1分钟
            if (timestamp && Date.now() - timestamp < 1000 * 60) {
              setHasPermission(hasPermission);
            } else {
              rbacPermissionMap.delete(uri);
              refreshPermission();
            }
          });
          return;
        }
        var promise = apiRbacUserHasPermission({
          appCode: appCode,
          showTypes: showTypes,
          uri: uri
        }).then(function (result) {
          if (result.code === 0) {
            return {
              timestamp: Date.now(),
              hasPermission: result.data.authResult
            };
          }
          return {
            timestamp: 0,
            hasPermission: false
          };
        });
        rbacPermissionMap.set(uri, promise);
        promise.then(function (result) {
          setHasPermission(result.hasPermission);
        });
      }
    };
    refreshPermission();
  }, [appCode, showTypes, uri]);
  return {
    hasPermission: hasPermission
  };
};